<template>
  <div>
    <article class="media">
      <div class="media-content">
        <div class="content">



          <div class="columns">
            <div class="column">
              <b-field label="Desde">
                <b-datepicker v-model="dateFrom" placeholder="Ingresa el primer rango" icon="calendar-today"
                  :readonly="false">
                </b-datepicker>
              </b-field>
            </div>

            <div class="column">
              <b-field label="Hasta">
                <b-datepicker v-model="dateTo" :min-date="dateFrom" placeholder="Ingresa el segundo rango"
                  icon="calendar-today" :readonly="false">
                </b-datepicker>
              </b-field>
            </div>

            <div class="column">
              <b-field label="Estado del archivo">
                <b-select v-model="statusFileSelected" placeholder="Selecciona un estado" expanded>
                  <option value="all">Todos</option>
                  <option v-for="option in statusFile" :value="option.id" :key="option.id">
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
            </div>

          </div>

          <div class="center">
            <button :disabled="!validateFilters" @click="searchReportOne"
              class="button is-info is-rounded ">Consultar</button>
          </div>

          <div class="btn-export" v-show="listFiles.length > 0">
            <div>
              <button  @click="downloadReportPdf" class="button  is-small">
              <!-- <button @click="downloadReport('pdf')" class="button  is-small"> -->
                <b-icon icon="file-pdf" class="colour-pdf"></b-icon> <span style="font-weight:bold"> Descargar PDF </span>
              </button>
              <button @click="downloadReportExcel" class="button  is-small">
                <b-icon icon="file-excel" class="colour-excel"></b-icon> <span style="font-weight:bold"> Descargar Excel
                </span>
              </button>
            </div>
          </div>



        </div>

        <div class="report">

          <h3 class="title is-size-6" v-show="total > 0">{{ total }} registros encontrados...</h3>

          <section>

            <b-pagination :total="total" :current.sync="current" order="is-centered" :size="size" :simple="false"
              :per-page="perPage" @change="pageChange">
            </b-pagination>
          </section>

          <section>

            <b-table :data="listFiles" :bordered="false" :striped="true" :narrowed="true" :hoverable="true"
              :loading="false" :mobile-cards="true">

              <template slot-scope="props">

                <b-table-column label="Cliente">
                  {{ getClientNameFromId(props.row.idClient) }}
                </b-table-column>

                <b-table-column label="Nombre">
                  {{ props.row.name }}
                </b-table-column>

                <b-table-column label="Código">
                  {{ props.row.code }}
                </b-table-column>

                <b-table-column label="Descripción">
                  <div class="break-word ">
                    {{ props.row.description }}
                  </div>
                </b-table-column>

                <b-table-column label="Fecha registro">
                  {{ new Date(props.row.registrationDate) | moment("DD-MM-YYYY - h:mm a") }}
                </b-table-column>

                <b-table-column label="Caja">
                  {{ props.row.box }}
                </b-table-column>

                <b-table-column label="Área">
                  {{ props.row.area }}
                </b-table-column>


                <b-table-column label="Estado">
                  {{ props.row.status | StatusFile }}
                </b-table-column>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large">
                      </b-icon>
                    </p>
                    <p>No hay resultados.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </section>
        </div>


      </div>
    </article>
  </div>
</template>

<script>
import Util from '../../../util'
import dateformat from 'dateformat';
import FileApi from "../../../store/modules/reports/actions";
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: "files-by-registration-date",
  data() {

    const statusFileList = Util.getStatusFiles()

    //const statusOrderList=Util.getStatusOrders()

    return {
      //statusOrder:statusOrderList,
      //statusOrderSelected:statusOrderList[0].id,
      dateFrom: null,
      dateTo: null,
      current: 1,
      perPage: 100,
      order: '',
      size: '',
      isSimple: false,
      pageSelected: 1,

      statusFileSelected: 'all',
      statusFile: statusFileList,
      listFiles: [],
      filters: {},
    }
  },


  methods: {
    ...mapActions({
      'loadFilesByRegistrationDateAndCategory': 'reports/loadFilesByRegistrationDateAndCategory',
      'exportFilesByRegistrationDateAndCategory': 'reports/exportFilesByRegistrationDateAndCategory',
      'exportExcelLoadFilesByRegistrationDate': 'reports/exportExcelLoadFilesByRegistrationDate',
      'reportFilesByRegistrationDate': 'reports/reportFilesByRegistrationDate',
      'reportFilesByRegistrationDateAndStatus': 'reports/reportFilesByRegistrationDateAndStatus',
    }),
    ...mapMutations({ 'setCountReportFiles': 'reports/setCountReportFiles', 'setFilesReport': 'reports/setFilesReport' }),
    checkReportOne() {
      this.loadFilesByRegistrationDateAndCategory({
        context: this,
        idClient: Util.getAuth().idClient,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        status: this.statusFileSelected,
        //idCategory: this.categorySelected,
        pageNumber: this.pageSelected,
        perPage: this.perPage
      }).then((data) => this.listFiles = data.files)
    },


    searchReportOne() {
      this.current = 1
      this.pageSelected = 1
      this.checkReportOne()
    },

    pageChange(page) {
      if (page == 0)
        page = 1
      this.pageSelected = page
      this.checkReportOne()
    },

    downloadReportExcel() {
      const exten = ".xlsx";
      this.exportFilesByRegistrationDateAndCategory(
        {
          context: this,
          idClient: Util.getAuth().idClient,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          status: this.statusFileSelected,
          pageNumber: this.pageSelected,
          perPage: this.perPage,
          exten,
          filename: `Reporte de Archivos - ${Util.getClient().name} - ${dateformat(Date.now(), "dd-mm-yyyy")}${exten}`
        }
      ).then()
    },

    downloadReportPdf() {
      const exten = ".pdf";
        this.reportFilesByRegistrationDate(
        {
          context: this,
          idClient: Util.getAuth().idClient,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          status: this.statusFileSelected,
          pageNumber: this.pageSelected,
          perPage: this.perPage,
          exten,
          filename: `Reporte de Archivos - ${Util.getClient().name} - ${dateformat(Date.now(), "dd-mm-yyyy")}${exten}`
        }
      ).then()  
    },

    // downloadReport(ext) {
    //   this.$dialog.prompt({
    //     message: `Se le enviará el reporte a su correo`,
    //     inputAttrs: {
    //       placeholder: "Ingrese email",
    //       maxlength: 30,
    //     },
    //     confirmText: "Aceptar",
    //     cancelText: "Cancelar",
    //     onConfirm: (email) => {
    //       const params = [`email=${email}`].join("&");
    //       this.filters.isExport = true;
    //       this.filters.extExport = ext;
    //       FileApi.loadReportFiles(this, {
    //         filters: this.filters,
    //         params,
    //       }).then();
    //     },
    //   });
    // },

    getClientNameFromId(id) {
      return Util.getClient(id).name
    },

  },

  computed: {
    ...mapGetters({ 'getFilesReport': 'reports/getFilesReport', 'getCountReportFiles': 'reports/getCountReportFiles' }),

    reportOne() {
      return this.reportSelected == '001'
    },
    reportTwo() {
      return this.reportSelected == '002'
    },
    validateFilters() {
      return (this.dateTo != null && this.dateFrom != null)
    },
    validateExport() {
      return this.validateFilters && this.getFilesReport.length > 0
    },
    total: {
      get() {
        return this.getCountReportFiles
      },
      set(value) {
        this.setCountReportFiles(value)
      }
    }
  },
  created() {
    this.current = 1
    this.pageSelected = 1
    this.setCountReportFiles(0)
    this.setFilesReport([])
  }

}
</script>

<style scoped>
.center {
  text-align: center;
}

.btn-export {
  text-align: right;
  margin-bottom: 0.25rem;
}

.break-word {
  word-break: break-all;
}

.colour-pdf {
  color: red;
}

.colour-excel {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/reportes/files/FilesByRegistrationDate.vue